import React from 'react';
import iconIaGradiente from 'assets/images/icone-ia-gradiente.svg';
import { Container } from './styles';

const openPersonalizar = () => window.dispatchEvent(new CustomEvent('open-match-personalizar'));

const MatchTopBanner: React.FC = () => (
  <Container>
    <span className="banner-label">
      <img src={iconIaGradiente} alt="IA" width={26} height={24} />
      Descreva o tipo de licitação ideal para sua empresa e torne o Match de Licitações mais
      compatível com seu perfil.
    </span>

    <div className="banner-actions">
      <button type="button" className="banner-btn-video">
        Assistir vídeo explicativo
      </button>
      <button type="button" className="banner-btn-personalizar" onClick={openPersonalizar}>
        <span>Personalizar</span>
      </button>
    </div>
  </Container>
);

export default MatchTopBanner;
